<template>
<!--  -->
<div ref='panelsP' fillHeight="lastHeight,-space">
	<div class="panel bgPanel ml1x mr1x tra" ref='panels' :screen='screenStatus' :style="this.reactDef">

		<div class="title">{{$t('word1909',['系统布局'])}}
			<div class="tool">
				<div class='dpIB ml1x_E fSub_E tra-fast_E hover-f-main_E'>
					<button v-permissions="'A/B/A3'" permission-type="none" v-if="doPermissions('A/B/A3',{targetCode:'A1',codeList:clone(roleCode)})" @click="edit" type="button" :title="$t('fill3rd143',[$t('word1909',['系统布局']),'编辑系统布局'])" onclick="statistic('A33','A3303')">
						<Icon :name="'edit'" class="ico w1x h1x"/>
					</button>
					<button onclick="statistic('A33','A3304')"  :class="{disable:screenBtnDisable}" type="button" @click='fullS' :title="screenStatus=='def'?getLanguageStr('word1910','全屏显示'):getLanguageStr('word1911','退出全屏')">
						<Icon :name="screenStatus=='def'?'fullScreen':'unFullScreen'" class="ico w1x h1x"/>
					</button>
				</div>
			</div>
		</div>
		<div class="tableSys dpB_E vaM_E">
			
			<div class='cField tra-fast_E vaM_E hover-cMain_E taR pr1x mr1x'>
				<button class="w2x fa fa-angle-left fs14x" :class="{disable:!time||dateSys.type==='all'}" @click="dateChange('perv')" type="button"></button>
				<vue-datepicker-local v-if="dateSys.type==='all'" v-model="rangeDate" format="YYYY" class="sizeS lh20" disabled></vue-datepicker-local>
				<vue-datepicker-local v-else v-model="dateSys.time" :format="dateSys.format[dateSys.type]" ref="date" class="sizeS lh20" @input="_showChartParam()" :disabled-date="disabledDate"></vue-datepicker-local>
				<button class="w2x fa fa-angle-right fs14x" :class="{disable:!time||dateSys.type==='all'||timeGetTime>=todayGetTime}" @click="dateChange('next')" type="button"></button>
				<div class='taR classGroup cField_E bdSub_E tra-fast_E'>
					<button type="button" :class="{active:ActiveIndex==index}" v-for="(item,index) in timeChoose" @click="_timePicker(item,index)" :key="index">{{item.datepicker}}</button>
				</div>
			</div>
			
		</div>
		<GenerateChart ref='GenerateChart' :ActiveIndex='ActiveIndex' :time='dateSys.time' :basicInfo='basicInfo' :timeZoneCode="timeZoneCode" :stationId='stationId' :systemId='systemId' :level='level' @DataHover="hoverTime" @LastData="lastData"></GenerateChart>
		<div class="colorRuler taC posA lh20">
			<!-- 
			<div class="max">{{layoutData.max>=0? convertData(layoutData.max,0,"","w")[0]:"--"}}</div>
			 -->
			<div class="max">{{layoutData.max>=0? floatFix(layoutData.max,0,(timeChoose[ActiveIndex].type=="day"?" W":" kWh")):"--"}}</div>
			<div class="range h10x boxR tra-fast" :class="{'range-bg':layoutData.max>0,lockLow:layoutData.max===0,bdSub:layoutData.max<0}"></div>
			<div class="min">{{layoutData.max>=0?"0"+(timeChoose[ActiveIndex].type=="day"?" W":" kWh"):"--"}}</div>
		</div>
		<PanelDisplay :roleCode='roleCode' :id="stationId" :systemId="systemId" :mode="'view'" :plantInfo="basicInfo" :timeType="this.timeChoose[this.ActiveIndex].type" :timeZoneCode="timeZoneCode" @AfterDataRender="afterDataRender" ref="PanelDisplay"></PanelDisplay>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import PanelDisplay from '@/view/maintain/light/plant/part/layout/PanelDisplay.vue';
import Edit from '@/view/maintain/light/plant/part/layout/Edit';
import GenerateChart from '@/view/maintain/light/plant/detail/GenerateChartForLayout';

import {apiGetTimeData} from '@/api/maintain/layout/index';

import Vue from 'vue'
export default{
	name:"LayoutView",
	components:{PanelDisplay,Edit,GenerateChart},
	props:{
		timeZoneCode:{
			type:String,
			default:stage.time.timeZoneCode
		},
		time:{//默认时间
			default:null
		},
		addClass:{//激活的索引项
			type:[String,Object],
			default:""
		},
		basicInfo: {
			type: Object,
			default: {}
    },
    roleCode: {
      type: Array,
			default: () => {
        return []
        }
    },
		collectTime: {
			type: Object,
			default: {}
		},
		stationId: {
			type: [String, Number],
			default: ''
		},
		systemId: {
			type: [String, Number],
			default: ''
		},
		level: {
			type: [String, Number],
			default: ''
		}
	},
	data(){
		return{
			reactOption:{},
			rangeDate: [new Date('2000'), new Date()],
			reactDef: {
				left: 'auto',
				right: 'auto',
				top: 'auto',
				bottom: 'auto',
				position: 'inherit'
			},
			screenStatus: 'def',
			screenBtnDisable: false,
			ActiveIndex: 0,
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
						// },{
						// 	datepicker:getLanguageStr("word1195","季度"),
						// 	format:'YYYY/MM',
						// 	type:'quarter'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'all'
			}],
			layoutData:{//布局数据
				timeData:{},//时间点数据
				max:-1,//最大数据
				lastTime:"",//当前hover的时间点
				loading:false//当前是否加载时间点数据中
			},
			dateSys:{
				type:"day",//时间档位
				format:{//使用格式
					day:"YYYY/MM/DD",
					month:"YYYY/MM",
					year:"YYYY",
					all:"YYYY"
				},
				time:lib.timeFormat(this.time||new Date(lib.timeFormat(new Date(),"utc","%Y-%m-%d",{offset:this.timeZoneCode})).getTime()/1000,"utc","%Y/%m/%d",{offset:this.timeZoneCode})
			},
		}
	},
	watch:{
		stationId:function(){//过快的操作可能未及时给到数据
			this.$refs.PanelDisplay.load({plantId:this.stationId});
		},
		systemId:function(){//过快的操作可能未及时给到数据
			this.$refs.PanelDisplay.load({systemId:this.systemId});
		},
		collectTime:{
			handler:function(v){
				if(v.lastUpdateTime){
					this.dateSys.time = new Date(this.timeFormat(v.lastUpdateTime,'utc','%Y/%m/%d',{offset:this.basicInfo.region.timezone}))
				}
			},
			deep:true
		}
	},
	methods:{
		getLanguageStr,
		floatFix:lib.floatFix,
		convertData:lib.convertData,
    timeFormat: lib.timeFormat,
    doPermissions: lib.doPermissions,
		...mapMutations({
			SETTOP: 'head/SETTOP'
		}),
		_showChartParam(){
			this.$nextTick(()=>{//给参数传递留出时间
				if (this.ActiveIndex == 0) { // 日
					this.$refs.GenerateChart._chartDay()
				} else if (this.ActiveIndex == 1) { // 月图表
					this.$refs.GenerateChart._chartMonth()
				}else if (this.ActiveIndex == 2) { // 年
					this.$refs.GenerateChart._chartYear()
				} else if (this.ActiveIndex == 3) { // 总
					this.$refs.GenerateChart._totalData()
				}
			});
    },
    clone (arr) {
			return _.cloneDeep(arr)
		},
		 dateChange (str) {
			//  console.log(str)
			// type day(日) week(周) month(月) year(年) all(总)
			let type = this.timeChoose[this.ActiveIndex].type
			let val=this.$refs.date.text;//lib.timeFormat(new Date(this.$refs.date.text),"system","%Y-%m-%d",{offset:this.timeZoneCode})
			// var date=new Date(val);
			// let today = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
			// let month = `${new Date().getFullYear()}-${new Date().getMonth()}`
			// let year = `${new Date().getFullYear()}`
			let today = lib.timeFormat(this.time,"utc","%Y/%m/%d",{offset:this.timeZoneCode})
			let month = lib.timeFormat(this.time,"utc","%Y/%m/01",{offset:this.timeZoneCode})
			let year = lib.timeFormat(this.time,"utc","%Y",{offset:this.timeZoneCode})
			// if(new Date(val).getTime()<new Date(today).getTime()){
			var date = new Date(type == 'month' || type == 'quarter' ? val.split('~').pop() + '/01' : val.split('~').pop())
			let step;
			switch (type) {
				case 'day':
					if (str === 'perv') {
						statistic('A33','A3305')
						step = -1
					} else if (str === 'next' && new Date(val).getTime() < new Date(today).getTime()){
						statistic('A33','A3307')
						step = 1
					} else {
						step = 0
					}
					// var step = str === 'next'&&new Date(val).getTime()<new Date(today).getTime() ? 1: -1
					if(step!=0){
						date.setDate(date.getDate() + step)
						this.$refs.date.selectOk(date)
					}
					break
				case 'month':
				// console.log(val)
				// console.log(month)
					val+='/01'	//Firefox的new Date不能解析月格式 “2019/10”，需要加日期 01
					if (str === 'perv') {
						statistic('A33','A3309')
						step = -1
					} else if (str === 'next' && new Date(val).getTime() < new Date(month).getTime()){//.replace(/\//g, '-')
						statistic('A33','A3311')
					// console.log(new Date(val).getTime())
					// console.log(new Date(month).getTime())
						step = 1
					} else {
						step = 0
					}
					if(step!=0){
						date.setMonth(date.getMonth() + step)
						this.$refs.date.selectOk(date);
					}
					break
				case 'quarter':
					if (str === 'perv') {
						step = -1
					} else if (str === 'next' && new Date(val).getTime() < new Date(today).getTime()) {
						step = 1
					} else {
						step = 0
					}
					if(step!=0){
						this.curQuarter = Math.ceil((date.getMonth() + 1 + step) / 3)
						date.setMonth(date.getMonth() + step)
						this.$refs.date.selectOk(date)
					}
					break
				case 'year':
					if (str === 'perv') {
						statistic('A33','A3313')
						step = -1
					} else if (str === 'next' && new Date(val).getTime() < new Date(year).getTime()) {
						statistic('A33','A3315')
						step = 1
					} else { 
						step = 0
					}
					if(step!=0){
						date.setFullYear(date.getFullYear() + step)
						this.$refs.date.selectOk(date)
					}
					break
				default:
					break
			}
		},
		_timePicker(item, index){
			this.dateSys.time = new Date(lib.timeFormat(this.collectTime.lastUpdateTime?this.collectTime.lastUpdateTime:(new Date())/1000,'utc','%Y/%m/%d',{offset:this.basicInfo.region.timezone}))
			switch (item.type) {
				case 'month':
					statistic('A33','A3308')
					break
				case 'year':
					statistic('A33','A3312')
					break
				case 'all':
					statistic('A33','A3316')
					break
			}
			this.dateSys.type = item.type
			this.ActiveIndex = index
			this.$refs.GenerateChart._timePicker(item,index)
		},
		fullS(){
			this.screenBtnDisable = true
			this.screenStatus === 'def' ? this.screenStatus = 'fullScreen' : this.screenStatus = 'def'
			this.reactDef = this.reactOption
			if(this.screenStatus === 'def'){
				this.SETTOP('0')
				setTimeout(()=>{
					// this.reactDef.position = 'inherit'
					this.reactDef = {
						left: 'auto',
						right: 'auto',
						top: 'auto',
						bottom: 'auto',
						position: 'inherit'
					}
				},500)
			}else{
				setTimeout(() => {
					this.reactDef = {
						left:'-1rem',
						top:0,
						right:'-1rem',
						bottom:'0rem',
						position:'fixed',
						"z-index":9
					}
					this.SETTOP('-4em')
				},100);
			}
			// setTimeout(() => {
			// 	this._showChartParam()
			// }, 300);
			setTimeout(() => {
				this.fillreset();
				// this.$refs.PanelDisplay.resize();
				// this.screenBtnDisable=false;
			},600);
		},
		getDateData:function(){//获取对应日期的数据
		},
		disabledDate(time){//禁用时间规则
			return this.time*1000 < time ;
		},
		getTimeData:function(timeData,keyId,keyValue){//加载时间点数据
			if(this.stationId&&this.systemId){
				this.layoutData.loading=true;
				let requestData=timeData;
				let parameExt = "";
				let unit="";
				switch(this.timeChoose[this.ActiveIndex].type){
					case "day":
						unit="W";
						break;
					case "month":
						requestData=lib.timeFormat(this.dateSys.time,"system","%Y%m")+timeData;
						unit="kWh";
						break;
					case "year":
						requestData={
							year:lib.timeFormat(this.dateSys.time,"system","%Y"),
							month:timeData
						}
						unit="kWh";
						parameExt = '_other'	//区分月和日
						break;
					// default:
					// 	break;
				}
				apiGetTimeData(this.systemId,requestData,this.timeChoose[this.ActiveIndex].type).then(success=>{
					this.layoutData.timeData[String(timeData)+parameExt]=success.records;
					this.$refs.PanelDisplay.panelDataRender(this.layoutData.timeData[String(timeData)+parameExt],unit,keyId,keyValue);
					this.layoutData.loading=false;
					if(this.layoutData.lastTime!=timeData){//自动查询最后时间点
						this.hoverTime(this.layoutData.lastTime);
					}
				},
				error=>{
					this.layoutData.loading=false;
				});
			}
		},
		hoverTime:function(timeData){//timeData:{dataX,...}
			// console.log(timeData)
			if(timeData){
				let x=0
				let keyValue="";//图表hover用的字段名
				let parameExt = "";
				let unit="";
				switch(this.timeChoose[this.ActiveIndex].type){
					case "day"://day需要换算数据
						if(timeData.dataX){//图表直接输出的数据是毫秒
							x=Math.floor(timeData.dataX/1000);
							x=Number(x)-mz.tz(this.timeZoneCode)._offset*60;
						}
						else{
							x=timeData;
						}
						unit="W";
						keyValue="generationPower";
						break;
					case "month":
						x=timeData.dataX||timeData;
						x=String(x).length<2? "0"+x:x;
						unit="kWh";
						keyValue="generationValue";
						break;
					case "year":
						unit="kWh";
						parameExt = "_other"	//区分月和日
					default:
						x=timeData.dataX||timeData;
						unit="kWh";
						keyValue="generationValue";
						break;
				}
				this.layoutData.lastTime=x;//记录当前hover点
				// trace(this.layoutData.timeData[String(timeData)])
				// console.log(this.layoutData.timeData)
				// console.log(String(x))
				// console.log(this.layoutData.timeData[String(x)+parameExt])
				if(this.layoutData.timeData[String(x)+parameExt]){//已有时间点数据
					this.$refs.PanelDisplay.panelDataRender(this.layoutData.timeData[String(x)+parameExt],unit,"deviceId",keyValue);
				}
				else{//走api取时间点数据
					if(x==undefined)trace(timeData,true)
					if(this.layoutData.loading==false) this.getTimeData(this.layoutData.lastTime,"deviceId",keyValue);
				}
			}else this.$refs.PanelDisplay.panelDataRender();
		},
		lastData:function(data){//图表加载后输出最后一条数据
			// console.log(data)
			this.hoverTime(data.length?{
				dataX:data[0]
			}:null);
		},
		afterDataRender:function(max){//获取渲染后输出的数据，对应展示
			this.layoutData.max=max;
		},
		edit:function(){//编辑布局
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],Edit,
					{id:this.stationId,systemId:this.systemId},
	//					{id:1242,systemId:1242},
					{Update:[this.onLayoutEdit.bind(this)]},{}
				).then(({instance, childInstance}) => {
					childInstance.show(null,this.basicInfo,instance);
				}
			);
		},
		onLayoutEdit:function(){//编辑组件已更新
			this.$refs.PanelDisplay.load();
		},
		reizeMethod(){
			Vue._debounce((v, ctx) => {
					let f = ctx.$refs.panels.getBoundingClientRect()
					let p = ctx.$refs.panelsP.getBoundingClientRect()
					let reactDef = Object.assign({	position: 'fixed'}, {left: p.left+'px',position:'fixed',
						right: 0+'em',
						top: p.top+'px',
						bottom: 1+'em'})
						// if(ctx.screenStatus === 'def'){
					
						// 	ctx.reactDef = reactDef
						// }
					ctx.reactOption = Object.assign({},reactDef)
			})('',this)
			
			},
			fillreset(){
				// if(this.collectTime.lastUpdateTime){
				// 	this.dateSys.time = new Date(this.timeFormat(this.collectTime.lastUpdateTime,'utc','%Y/%m/%d',{offset:this.basicInfo.region.timezone}))
				// }
				lib.fillHeight();

				this.$nextTick(()=>{
					let p = this.$refs.panelsP.getBoundingClientRect()
					let f = this.$refs.panels.getBoundingClientRect()
					this.reactOption = Object.assign({	position: 'fixed'}, {	left: p.left+'px',position:'fixed',
						right: 0+'em',
						top: p.top+'px',
						bottom: 1+'em'})
					// this.reactOption = Object.assign({},this.reactDef)
				});
				this.$refs.PanelDisplay.show();
				this._showChartParam()
				this.screenBtnDisable = false
			}

	},
	computed:{
		...mapGetters({
			top:'head/top'
		}),
		timeGetTime () {
		  let year = new Date(this.dateSys.time).getFullYear()
		  let month = new Date(this.dateSys.time).getMonth() + 1
		  let day = new Date(this.dateSys.time).getDate()
		  if (this.ActiveIndex == 0) {
		    return new Date(year + '/' + month + '/' + day).getTime()
		  } else if (this.ActiveIndex == 1) {
		    return new Date(year + '/' + month + '/01').getTime()
		  } else if (this.ActiveIndex == 2) {
		    return new Date(String(year)).getTime()
		  }
		},
		todayGetTime () {
		  if (this.ActiveIndex == 0) {
		    return new Date(lib.timeFormat(this.time,"utc","%Y/%m/%d",{offset:this.timeZoneCode})).getTime()
		  } else if (this.ActiveIndex == 1) {
		    return new Date(lib.timeFormat(this.time,"utc","%Y/%m/01",{offset:this.timeZoneCode})).getTime()
		  } else if (this.ActiveIndex == 2) {
		    return new Date(lib.timeFormat(this.time,"utc","%Y",{offset:this.timeZoneCode})).getTime()
		  }
		}
	},
	created(){
	},
	destroyed(){
		this.$bus.$off('resizePB')
	},
	mounted(){
		statistic('A33','A3301')
		if(this.collectTime.lastUpdateTime){
			this.dateSys.time = new Date(this.timeFormat(this.collectTime.lastUpdateTime,'utc','%Y/%m/%d',{offset:this.basicInfo.region.timezone}))
		}

		lib.fillHeight();
		this.$bus.$on('resizePB',this.reizeMethod.bind(this))
    
		this.$nextTick(()=>{
			let p = this.$refs.panelsP.getBoundingClientRect()
			let f = this.$refs.panels.getBoundingClientRect()
			this.reactOption = Object.assign({	position: 'fixed'}, {	left: p.left+'px',
				right: 0+'em',
				top: p.top+'px',
				bottom: 1+'em'})
			// this.reactOption = Object.assign({},this.reactDef)
		});
		this.$refs.PanelDisplay.show();
	}
}
</script>
<style lang="scss" scoped>
.tool{
	.ico{
		font-size: 1.5em
	}
	
}
.r0x{
		right: 0
	}



// .panel[screen="def"]{
// 	position: fixed;top:unset;bottom:unset;left:unset;right:unset;
// }
// .panel[screen="fullScreen"]{
// 	position: fixed;
// 	top: 0;
// 	left: -1em;
// 	right: -1em;
// 	bottom: 0em;
// }

</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/layout/View.vue